import axios from "axios";

// Create an Axios instance with a default base URL
const apiClient = axios.create({
  // baseURL: "http://localhost:5000/api/",
  // baseURL: "http://localhost:5000/api/",
  baseURL: "https://api.homesdekho.com/api/",
});

export default apiClient;
